function CartPromo({ cart, className = '', isMiniCart = false }) {
  const { promoBanner } = GM_STATE.cart

  if (!promoBanner || !promoBanner.type || !promoBanner.enabled) return null

  let content = ''
  let code = null
  let progressBarWrapper = ''
  let lockedThresholds = []
  let progressBar = ''

  if (promoBanner.type === 'threshold') {
    if (!promoBanner.threshold_discount_collection) return null

    const subtotal = cart.items.reduce((sum, item) => {
      if (item.collections.includes(promoBanner.threshold_discount_collection)) {
        return sum + item.original_line_price
      }
      return sum
    }, 0)

    if (subtotal === 0) return null

    const totalPrice = subtotal / 100
    const currency = '$'
    const thresholds = promoBanner.thresholds || []
    const sortedThresholds = [...thresholds].sort((a, b) => a.threshold_amount - b.threshold_amount)
    const nextThreshold = sortedThresholds.find(t => totalPrice < t.threshold_amount) // Single object
    const unlockedThreshold = sortedThresholds.filter(t => totalPrice >= t.threshold_amount).pop() // Single object
    lockedThresholds = sortedThresholds.filter(t => totalPrice < t.threshold_amount) // Array

    if (nextThreshold) {
      const diff = (nextThreshold.threshold_amount - totalPrice).toFixed(2)
      content = promoBanner.threshold_title_unlocked.replace('%amount%', `${currency}${diff}`)
    } else if (unlockedThreshold) {
      content = promoBanner.threshold_title_complete.replace('%percentage%', `${unlockedThreshold.percentage_discount}%`)
    }

    if (nextThreshold) {
      const lockedElements = lockedThresholds.map((threshold, idx) => {
        if ((!unlockedThreshold && threshold !== nextThreshold) || unlockedThreshold) {
          return <div className="flex justify-end items-center px-2 py-1.5 rounded-sm bg-[#F6F6F6] text-[#363636] text-xs" key={`locked-${idx}`}>{threshold.percentage_discount}% OFF</div>
        }
        return null
      })

      if (unlockedThreshold) {
        progressBar = (
          <div className="flex rounded-sm overflow-hidden flex-1">
            <div className="relative flex-1 bg-[#F6F6F6]">
              <div style={`background-color: ${promoBanner.accentColor}`} className="h-full text-[#F6F6F6] flex items-center justify-end px-2 py-1.5 text-xs">
                <span className="hidden md:block">
                  {promoBanner.threshold_title_complete.replace('%percentage%', `${unlockedThreshold.percentage_discount}%`)}
                </span>
                <span className="md:hidden">
                  {promoBanner.threshold_title_complete_mobile.replace('%percentage%', `${unlockedThreshold.percentage_discount}%`)}
                </span>
              </div>
            </div>
          </div>
        )
      } else {
        const progress = (totalPrice / nextThreshold.threshold_amount) * 100

        progressBar = (
          <div className="flex rounded-sm overflow-hidden flex-1">
            <div className="relative flex-1 bg-[#F6F6F6]">
              <div style={`background-color: ${promoBanner.accentColor}; width: ${progress}%`} className="h-full" />
            </div>
            <div className="bg-[#F6F6F6] text-[#363636] text-xs flex justify-center items-center whitespace-nowrap px-2 py-1.5">
              {nextThreshold.percentage_discount}% OFF
            </div>
          </div>
        )
      }

      progressBarWrapper = (
        <div className={`w-full flex gap-1 ${isMiniCart ? '' : 'md:max-w-[380px]'}`}>
          {progressBar}
          {lockedElements}
        </div>
      )
    }
  } else if (promoBanner.type === 'bogo') {
    if (!promoBanner.bogo.collections || !promoBanner.bogo.lockedLabel) return null
    const eligibleCollectionHandles = promoBanner.bogo.collections?.map(col => col.handle) || []

    const totalQty = cart.items.reduce((sum, item) => {
      const isInEligibleCollection = item.collections?.some(colHandle => eligibleCollectionHandles.includes(colHandle))
      return isInEligibleCollection ? sum + item.quantity : sum
    }, 0)

    if (totalQty === 0) return

    const totalQtyRemainder = totalQty % 2
    const maxProductQty = promoBanner.bogo.bogoMaxUses ? promoBanner.bogo.bogoMaxUses * 2 : null

    const isMaxReached = maxProductQty !== null && totalQty >= maxProductQty
    const isEvenQty = totalQtyRemainder === 0 // Checks if eliglible product qty is even number

    if (isEvenQty || isMaxReached) {
      content = promoBanner.bogo.unlockedLabel
    } else {
      const label = promoBanner.bogo.lockedLabel
      const parts = label.split('1')

      content = (
        <>
          {parts[0]}
          <span className='w-[23px] h-[23px] inline-flex items-center justify-center rounded-full' style={`background-color:${promoBanner.accentColor}`}>1</span>
          {parts[1]}
        </>
      )
    }
  } else if (promoBanner.type === 'simple') {
    if (!promoBanner.content) return null
    content = promoBanner.content || ''
    code = promoBanner.code || null
  }

  if (!content) return null

  return (
    <div className={className}>
      <div
        className={`${promoBanner.type === 'bogo' ? 'px-4' : 'px-6'} pt-3 pb-4 text-center text-sm font-medium flex flex-col gap-2 ${
          isMiniCart ? '' : 'flex-wrap items-center justify-center md:flex-row md:gap-8 md:py-4'
        }`}
        style={{
          backgroundColor: promoBanner.bgColor,
          color: promoBanner.textColor
        }}
      >
        <p>{content}</p>
        {
          lockedThresholds.length ? progressBarWrapper : ''
        }
        {code && (
          <p className={isMiniCart ? '-mt-1' : ''}>
            Use code <strong className="font-bold">{code}</strong>
          </p>
        )}
      </div>
    </div>
  )
}

export default CartPromo
